// extracted by mini-css-extract-plugin
export default {"SingleSubjects":"qg3lD86UndRCW3THG18Z","Heading":"RYgRkwoRw1xWtjmL644h","CategoryTab":"SeivH7347X3iE9uttPyr","TabHeading":"mzOQ1OlwQPZ8TFejoIpk","ItemList":"i5pK9wD7_wYzGZFSZE_p"};